import { Meteor } from 'meteor/meteor';
import { get } from 'lodash';
import handleMethodException from '../../../modules/handle-method-exception';
import packageJSON from '../../../../package.json';
/**
 * Gets the app version from the package.json.
 *
 * @returns {string} The version for the app.
 * @throws {Error} Meteor Error if anything goes wrong.
 */
export const getAppVersion = () => {
  try {
    return packageJSON.version;
  } catch (exception) {
    return handleMethodException(exception);
  }
};

/**
 * Gets the app deployment environment.
 *
 * @returns {string} The deployment environment for the app.
 * @throws {Error} Meteor Error if anything goes wrong.
 */
export const getDevEnvironment = () => {
  try {
    return get(Meteor.settings, 'private.config.deploymentEnv', '');
  } catch (exception) {
    return handleMethodException(exception);
  }
};

/**
 * Gets the url for Tierra2 API.
 *
 * @param {boolean} authenticated - Is the user authenticated or not.
 * @returns {string} The Tierra2 API url.
 * @throws {Error} Meteor Error if anything goes wrong.
 */
export const getTierra2API = authenticated => {
  try {
    if (authenticated) {
      return get(Meteor.settings, 'private.loggedInTierra2API', '');
    }
    return get(Meteor.settings, 'private.notLoggedInTierra2API', '');
  } catch (exception) {
    return handleMethodException(exception);
  }
};
